import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Injectable } from '@angular/core';
import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { environment } from '../../../environments/environment';
import { UserPersistenceService } from '../../core/services/userPersistence.service';
import { Enums } from '../../shared/models/enums';
import { IMoreInfoData } from './../../../app/shared/interfaces/moreInfo.interface';
import { ModalService } from './../../shared/services/modal.service';
import { InfoPageModalComponent } from './more-info-page-modal.component';


@Injectable()
export class MoreInfoCommonService {
    modalRef: MDBModalRef;
    confirmationStatus = Enums.confirmationStatus;
    private measureHeaderKey: string = 'EffMeasures';
    private tooltipText: string = 'ToolTip';
    private textProperty: string = 'Text';
    measureImagesUrl =environment.API_URL + '/api/measureimagedetails/getMeasureimagedetailsbyid';
    constructor(
        private modalService: ModalService,
        public userPersistenceService: UserPersistenceService,
        private http: HttpClient,
    ) {
    }

    showMoreInfo(moreInfoData: IMoreInfoData) {
        let modalOptions;
        if (moreInfoData.version == '3.0') {
            modalOptions = {
                class: 'modal-fluid modal-full-height modal-right calculator',
                containerClass: 'right',
                data: this.getMoreInfoDataV3(moreInfoData)
            };
        } else {
            modalOptions = {
                class: 'modal-fluid modal-full-height modal-right calculator',
                containerClass: 'right',
                data: this.getMoreInfoData(moreInfoData)
            };
        }

        this.modalRef = this.modalService.openModal(InfoPageModalComponent, modalOptions);

        this.modalRef.content.action.subscribe((result: any) => {
            if (result.status == this.confirmationStatus.ok) {
                this.modalRef.hide();
            }
        });
    }

    private getMoreInfoData(moreInfoData: IMoreInfoData): any {
        let tabName = this.getTabNameFromMeasure(moreInfoData.measure);

        let heading = moreInfoData.staticText[tabName + this.measureHeaderKey];

        const rawToolTip = moreInfoData.toolUI?.[moreInfoData.measure + this.tooltipText] ?? '';
        let toolTip = rawToolTip.split('|');

        let pageNo = toolTip[0];
        let meaureDescription = toolTip[1];
        let measureText = '';

        measureText = moreInfoData.tool[moreInfoData.measure + this.textProperty];

        if (!measureText) {
            measureText = moreInfoData.toolUI[moreInfoData.measure + this.textProperty];
        }

        if (!measureText) {
            measureText = moreInfoData.staticText[moreInfoData.measure + this.textProperty];
        }

        let materialDescriptions: Array<string> = [];
        if (tabName === 'material') {
            materialDescriptions.push(moreInfoData.staticText['baselineAssumptions']);
            materialDescriptions.push(moreInfoData.staticText[moreInfoData.measure + 'Text_Line1']);
            materialDescriptions.push(moreInfoData.tool[moreInfoData.measure + 'Text_Line2']);
            materialDescriptions.push(moreInfoData.tool[moreInfoData.measure + 'Text_Line3']);
        }

        return {
            heading: heading, measureText: measureText, meaureDescription: meaureDescription,
            pageNo: pageNo, materialDescriptions: materialDescriptions,
            moreInfo: this.userPersistenceService.generalTranslation.Moreinfo,
            toolName: moreInfoData.toolName,
            tabName: tabName.toUpperCase(),
            measure: moreInfoData.measure
        };
    }

    private getMoreInfoDataV3(moreInfoData: IMoreInfoData): any {
        
        let tabName = this.getTabNameFromMeasureV3(moreInfoData.measure);

        let heading = moreInfoData.staticText[tabName + this.measureHeaderKey];

        const rawToolTip = moreInfoData.toolUI?.[moreInfoData.measure + this.tooltipText] ?? '';
        let toolTip = rawToolTip.split('|');

        let pageNo = toolTip[0];
        //let toolTip = " ";
        //let pageNo = " ";

       /* let meaureDescription = "Description Coming Soon..";*/
        let measureText = '';

        measureText = moreInfoData.tool[moreInfoData.measure + 'Label'];

        // if (!measureText) {
        //     measureText = moreInfoData.toolUI[moreInfoData.measure + this.textProperty];
        // }

        // if (!measureText) {
        //     measureText = moreInfoData.staticText[moreInfoData.measure + this.textProperty];
        // }

        let materialDescriptions: Array<string> = [];
        if (tabName === 'material') {
           // materialDescriptions.push(moreInfoData.staticText['baselineAssumptions']);
            materialDescriptions.push(moreInfoData.staticText[moreInfoData.measure + 'Text_Line1']);
            materialDescriptions.push(moreInfoData.tool[moreInfoData.measure + 'Text_Line2']);
            materialDescriptions.push(moreInfoData.tool[moreInfoData.measure + 'Text_Line3']);
        }

        return {
            heading: heading, measureText: measureText, 
            pageNo: pageNo, materialDescriptions: materialDescriptions,
            moreInfo: this.userPersistenceService.generalTranslation.Moreinfo,
            toolName: moreInfoData.toolName,
            tabName: tabName.toUpperCase(),
            version: 3.0,
            measure: moreInfoData.measure,
            tool: moreInfoData.tool.primaryBuildingType
        };
    }

    private getTabNameFromMeasure(measureId: string): string {
        let initial = measureId.substr(2, 1).toUpperCase();

        switch (initial) {
            case 'E':
                return 'energy';
            case 'W':
                return 'water';
            case 'M':
                return 'material';
            default:
                return '';
        }
    }

    private getTabNameFromMeasureV3(measureId: string): string {
        let initial = measureId.substr(0, 1).toUpperCase();

        switch (initial) {
            case 'E':
                return 'energy';
            case 'W':
                return 'water';
            case 'M':
                return 'material';
            default:
                return '';
        }
    }

    //getMeasureImageDetailsById(measureTypeId: any) {
    //    return this.http.get<any>(this.measureImagesUrl + '?measureTypeId=' + measureTypeId);
    //}

    getMeasureImageDetailsById(toolName: string, measure: string) {
        //toolName = 'Education';
        //measure = 'EEM01';
        return this.http.get<any>(this.measureImagesUrl + '?toolName=' + toolName + '&measureName=' + measure);
    }
}